import script from "./RolesTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./RolesTable.vue?vue&type=script&setup=true&lang=ts"

import "./RolesTable.vue?vue&type=style&index=0&id=93cfce24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93cfce24"]])

export default __exports__